import stringifyJSObject from '../../../../utils/stringifyJSObject'

export const DefaultOptions = {
  tabWidth: 2,
  useTabs: false
}

/**
 * 將 JSON 轉為 JS Object
 * @param {string} input
 * @param {object} options
 * @returns {Promise<string>} output
 */
export default async function convertJSONToJSObject(input, options) {
  const object = JSON.parse(input)
  return stringifyJSObject(object, {...DefaultOptions, ...options})
}
